import { Box, CircularProgress, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { getShareholders } from "../../data/request";
import { ShareholdersResponse } from "../../types/Shareholders";
import * as Utilities from "../../data/utilities";
import { TEXT_SECONDARY } from "../colors";
import { ShareholdersChart } from "./ShareholdersChart";
import { ShareholdersTable } from "./ShareholdersTable";

export const ShareholdersPanel = (props: { companyNo: string | undefined }) => {
  const { companyNo } = props;
  const [response, setResponse] = useState<ShareholdersResponse>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      if (companyNo == undefined) {
        return;
      }
      setLoading(true);
      const doc = await getShareholders(companyNo);
      setResponse(doc);
      setLoading(false);
    };

    fetchData();
  }, [companyNo]);

  if (loading) {
    return (
      <Box
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: 200,
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (!response?.available || response.shareholders.length === 0) {
    return (
      <Box style={{ padding: 20 }}>
        <Typography variant="body2" style={{ color: TEXT_SECONDARY }}>
          Shareholder data not available for this company. Companies House only publishes a full
          shareholder breakdown inside certain confirmation statements, and older filings are often
          not available in a machine-readable format. Check the Filing History tab for their
          confirmation statements directly.
        </Typography>
      </Box>
    );
  }

  const showClass = response.classes.length > 1;

  return (
    <Box>
      {response.statement_date && (
        <Typography variant="body2" style={{ color: TEXT_SECONDARY, padding: "10px 10px 0" }}>
          As at {Utilities.getDateDisplay(response.statement_date)}
        </Typography>
      )}
      <ShareholdersChart shareholders={response.shareholders} classes={response.classes} />
      <ShareholdersTable shareholders={response.shareholders} showClass={showClass} />
    </Box>
  );
};

export default ShareholdersPanel;
